document.addEventListener("DOMContentLoaded", function() {

  const killZoom = () => {

    document.querySelectorAll(

      ".product-card__image, .card-gallery, .collection-card__image, .resource-card__image"

    ).forEach(img => {

      img.style.transform = "none";

      img.style.scale = "1";

      img.style.transition = "none";

    });

  };

  // Run once

  killZoom();

  // Run again after hover events (Shopify re-applies transforms)

  document.body.addEventListener("mouseover", killZoom, true);

  document.body.addEventListener("mousemove", killZoom, true);

});
